<div class="sk-cms-nodata">
    {{if isDesign}}
    <span class="text">
        请点击左侧 "组件" 菜单进行添加
    </span>
    {{/if}}
</div>